export default "__VITE_ASSET__CZFL0uN2__"